import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../../components/ThemeProvider'
import { dictionaries } from '../utils/dictionaries'
import { decodeFromDictionary } from '../types'

type Props = {
  data: any
}

const rows = [
  { label: '成功还款笔数', key: 'xyp_cpl0014' },
  { label: '交易失败笔数', key: 'xyp_cpl0015' },
]

export default function RepaymentTable({ data }: Props) {
  const theme = useTheme()

  return (
    <Stack gap="sm">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        还款与交易情况
      </Text>
      <Table
        highlightOnHover
        verticalSpacing="sm"
        withColumnBorders={false}
        styles={{
          table: { fontSize: '13px', tableLayout: 'fixed' },
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '40%' }}>指标</Table.Th>
            <Table.Th style={{ width: '60%' }}>区间</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row) => (
            <Table.Tr key={row.key}>
              <Table.Td>{row.label}</Table.Td>
              <Table.Td>{decodeFromDictionary(dictionaries, row.key, data?.[row.key])}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
